import React from "react"
import { Player } from "@lottiefiles/react-lottie-player"

class Animation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
    }
    this.player = React.createRef()
  }

  componentDidMount() {
    if (!this.state.isMobile) {
      if (window.innerWidth <= 575) {
        this.setState({ isMobile: true })
      }
    }
    console.log("thth", this.state.isMobile)
  }

  playAnimation(e) {
    this.player.current.play()
  }

  stopAnimation(e) {
    this.player.current.pause()
  }

  render() {
    return (
      <div
        className="play-annimation"
        onMouseOver={e => this.playAnimation(e)}
        onMouseOut={e => this.stopAnimation(e)}
      >
        {this.state.isMobile ? (
          <>
            <></>
            <Player
              ref={this.player}
              autoplay={true}
              loop={true}
              src={this.props.data}
              style={{
                height: this.props.animationHeight,
                width: this.props.animationWidth,
              }}
            ></Player>
          </>
        ) : (
          <Player
            ref={this.player}
            autoplay={false}
            loop={true}
            src={this.props.data}
            style={{
              height: this.props.animationHeight,
              width: this.props.animationWidth,
            }}
          ></Player>
        )}
      </div>
    )
  }
}

export default Animation
